import { IconEye, IconEyeOff } from '@tabler/icons-react';
import type { ComponentProps } from 'react';
import React, { useState } from 'react';
import { InputField } from './InputField';

type PasswordFieldProps = Omit<
  ComponentProps<typeof InputField>,
  'type' | 'icon'
>;

type PasswordIconProps = {
  showPassword: boolean;
  disabled: boolean | undefined;
  onToggle: () => void;
};

const PasswordIcon = ({
  showPassword,
  disabled,
  onToggle,
}: PasswordIconProps) => (
  <button
    type="button"
    onClick={onToggle}
    className="rounded-full p-1 text-rw-neutral-gray hover:text-primary-teal focus:outline-none focus:ring-2 focus:ring-primary-teal focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
    disabled={disabled}
    aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
  >
    {showPassword ? (
      <IconEyeOff className="size-4" />
    ) : (
      <IconEye className="size-4" />
    )}
  </button>
);

export const PasswordField = React.forwardRef<
  HTMLInputElement,
  PasswordFieldProps
>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <InputField
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      icon={
        <PasswordIcon
          showPassword={showPassword}
          disabled={props.disabled}
          onToggle={togglePasswordVisibility}
        />
      }
      {...props}
    />
  );
});

PasswordField.displayName = 'PasswordField';
